
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m466.5 83.7-192-80a48.15 48.15 0 0 0 -36.9 0l-192 80c-17.9 7.4-29.6 24.9-29.6 44.3 0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0 85.7-35.7 221.6-159 221.6-380.3 0-19.4-11.7-36.9-29.5-44.3zm-204.3 395.1c-3.9 1.6-8.3 1.6-12.3 0-97.9-38.8-201.9-174.8-201.9-350.8 0-6.5 3.9-12.3 9.8-14.8l192-80c3.8-1.6 8.3-1.7 12.3 0l192 80c6 2.5 9.8 8.3 9.8 14.8.1 176-103.9 312-201.7 350.8z"}})])
          )
        }
      }
    